module.exports = __webpack_public_path__ + "static/animal-farm-e902fb43c1ea07839950586dbb7b9a35.jpg";